export default {
  GET_ERROR: {
    title: 'There was an issue getting the appointment information'
  },
  NO_APPOINTMENT_ERROR: {
    severity: 'error' as 'error',
    title: 'Unable to find the appointment',
    subtitle: 'You will be redirected to the Connect Care Landing screen.'
  },
  START_APPOINTMENT_ERROR: {
    severity: 'error' as 'error',
    title: 'Unable to start the appointment',
    subtitle: 'Try contacting your provider or press on the "Help" button for assistance'
  }
};
